
import {forkJoin as observableForkJoin, Observable} from 'rxjs';
import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot, Router} from "@angular/router";
import {EventService} from "../services/event.service";
import {NationalTeamsService} from '../services/national-teams.service';

@Injectable()
export class ConstituentDataResolver implements Resolve<any> {
    constructor(
        private eventService: EventService,
        private nationalTeamsService: NationalTeamsService,
        private router: Router
    ) {}


    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any>|Promise<any>|any {
        const eventsObs = this.eventService.getConstituentEvents(route);
        const nationalTeamsObs = this.nationalTeamsService.reloadConstituentNationalTeams(route);
        return observableForkJoin(eventsObs, nationalTeamsObs);
    }
}
